import { NavLink, Outlet } from 'react-router';
import { ROLE_LABELS } from '@agencia/shared';
import { useAuth, useCurrentUser } from '@/auth/AuthContext';
import { logos } from '@/brand';

function initials(nome: string): string {
  const parts = nome.trim().split(/\s+/);
  return ((parts[0]?.[0] ?? '') + (parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '')).toUpperCase();
}

const Icon = {
  painel: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
      <rect x="3" y="3" width="7" height="9" rx="1.5" />
      <rect x="14" y="3" width="7" height="5" rx="1.5" />
      <rect x="14" y="12" width="7" height="9" rx="1.5" />
      <rect x="3" y="16" width="7" height="5" rx="1.5" />
    </svg>
  ),
  vendas: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
      <path d="M4 5h16M4 12h16M4 19h10" />
    </svg>
  ),
  eu: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
      <path d="M4 19l5-6 4 3 7-9" />
    </svg>
  ),
  alertas: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
      <path d="M12 3l9 16H3L12 3zM12 10v4M12 17h.01" />
    </svg>
  ),
  metas: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="12" cy="12" r="0.5" />
    </svg>
  ),
  fechamentos: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
      <rect x="4" y="5" width="16" height="15" rx="2" />
      <path d="M8 3v4M16 3v4M4 10h16M9 15l2 2 4-4" />
    </svg>
  ),
  clientes: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 5h18l-7 8v6l-4 2v-8z" />
    </svg>
  ),
  relatorio: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
      <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
    </svg>
  ),
  links: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
      <path d="M10 14a4 4 0 005.7 0l3-3a4 4 0 00-5.7-5.7l-1 1" />
      <path d="M14 10a4 4 0 00-5.7 0l-3 3a4 4 0 005.7 5.7l1-1" />
    </svg>
  ),
  simulador: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
      <rect x="5" y="3" width="14" height="18" rx="2" />
      <path d="M8 7h8M8 11h2M12 11h0M16 11h0M8 15h2M12 15h0M16 15v3M8 18h2M12 18h0" />
    </svg>
  ),
  voos: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M2 16l20-6-2-3-7 3-5-6-2 1 3 6-5 2-2-2-1 1 1 4z" />
      <path d="M3 21h18" />
    </svg>
  ),
  pagamentos: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
      <rect x="3" y="6" width="18" height="13" rx="2" />
      <path d="M3 10h18M7 15h4" />
    </svg>
  ),
  usuarios: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
      <circle cx="9" cy="8" r="3.5" />
      <path d="M2.5 20c.8-3.5 3.4-5.5 6.5-5.5s5.7 2 6.5 5.5" />
      <path d="M16 4.5a3.5 3.5 0 010 7M18.5 14.8c1.6.8 2.7 2.5 3 5.2" />
    </svg>
  ),
  integracoes: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
      <path d="M4 12a8 8 0 0113.7-5.6L20 9M20 4v5h-5M20 12a8 8 0 01-13.7 5.6L4 15M4 20v-5h5" />
    </svg>
  ),
  senha: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
      <rect x="4" y="10" width="16" height="11" rx="2" />
      <path d="M8 10V7a4 4 0 018 0v3" />
    </svg>
  ),
  sair: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
      <path d="M15 4h4v16h-4M10 8l-4 4 4 4M6 12h10" />
    </svg>
  ),
};

/** Estrutura das telas internas: menu lateral (azul-marinho Fly Now) + conteúdo. */
export function AppShell() {
  const user = useCurrentUser();
  const { logout } = useAuth();
  const gestao = user.role === 'ADMIN' || user.role === 'GESTOR';

  return (
    <div className="shell">
      <nav className="shell__nav" aria-label="Menu principal">
        <div className="brand">
          <img src={logos.fClaro} alt="" width={40} height={40} />
          <div>
            <strong>Fly Now Viagens</strong>
            <span>Gestão de vendas</span>
          </div>
        </div>

        <div className="nav-links">
          <NavLink to="/" end className="nav-link">
            {Icon.painel} {gestao ? 'Equipe' : 'Painel'}
          </NavLink>
          {gestao && user.vendedor && (
            <NavLink to="/meu-desempenho" className="nav-link">
              {Icon.eu} Meu desempenho
            </NavLink>
          )}
          <NavLink to="/clientes" className="nav-link">
            {Icon.clientes} {gestao ? 'Clientes' : 'Meus clientes'}
          </NavLink>
          {gestao && (
            <NavLink to="/relatorio-clientes" className="nav-link">
              {Icon.relatorio} Relatório de clientes
            </NavLink>
          )}
          {gestao && (
            <NavLink to="/links-de-origem" className="nav-link">
              {Icon.links} Links de origem
            </NavLink>
          )}
          <NavLink to="/proximos-voos" className="nav-link">
            {Icon.voos} Próximos voos
          </NavLink>
          <NavLink to="/vendas" className="nav-link">
            {Icon.vendas} {gestao ? 'Vendas' : 'Minhas vendas'}
          </NavLink>
          {gestao && (
            <NavLink to="/alertas" className="nav-link">
              {Icon.alertas} Alertas
            </NavLink>
          )}
          {gestao && (
            <NavLink to="/metas" className="nav-link">
              {Icon.metas} Metas
            </NavLink>
          )}
          <NavLink to="/simulador" className="nav-link">
            {Icon.simulador} Simulador
          </NavLink>
          <NavLink to="/links-de-pagamento" className="nav-link">
            {Icon.pagamentos} Links de pagamento
          </NavLink>
          <NavLink to="/fechamentos" className="nav-link">
            {Icon.fechamentos} Fechamentos
          </NavLink>
          {user.role === 'ADMIN' && (
            <NavLink to="/usuarios" className="nav-link">
              {Icon.usuarios} Usuários
            </NavLink>
          )}
          {user.role === 'ADMIN' && (
            <NavLink to="/integracoes" className="nav-link">
              {Icon.integracoes} Integrações
            </NavLink>
          )}
          <NavLink to="/minha-senha" className="nav-link">
            {Icon.senha} Minha senha
          </NavLink>
        </div>

        <div className="nav-user">
          <div className="avatar" aria-hidden="true">
            {initials(user.nome)}
          </div>
          <div className="nav-user__info">
            <strong>{user.nome}</strong>
            <span>{user.role === 'ADMIN' ? 'Administrador e gestor' : ROLE_LABELS[user.role]}</span>
          </div>
          <button type="button" className="icon-btn" aria-label="Sair" title="Sair" onClick={() => void logout()}>
            {Icon.sair}
          </button>
        </div>
      </nav>

      <main className="shell__main">
        <Outlet />
      </main>
    </div>
  );
}
